export function updateTitle(title) {
    document.title = title;
}

function getTitle() {
    return document.title;
}

export default [() => ({ updateTitle, getTitle })];
